<template>
  <div>
    <error-page></error-page>
  </div>
</template>

<script>
import ErrorPage from "@/views/components/ErrorPage.vue";

export default {
  components: {
    ErrorPage,
  },
};
</script>

<style scoped></style>
